import { render } from "./ContentsHeader.vue?vue&type=template&id=38b3d858&scoped=true"
import script from "./ContentsHeader.vue?vue&type=script&lang=js"
export * from "./ContentsHeader.vue?vue&type=script&lang=js"

import "./ContentsHeader.vue?vue&type=style&index=0&id=38b3d858&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38b3d858"]])

export default __exports__